import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

/** Table / wide layout: from `md` upward */
export const detailDataTableOnlySx: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  width: "100%",
};

/** Stacked cards: below `md` */
export const detailDataCardsOnlySx: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  width: "100%",
};

/** Scrollable card list on narrow viewports (replaces horizontal table scroll) */
export const detailDataCardsScrollStackSx: SxProps<Theme> = {
  ...detailDataCardsOnlySx,
  gap: 1.5,
  maxHeight: "min(65vh, 560px)",
  overflowY: "auto",
  pr: 0.5,
  boxSizing: "border-box",
};

type FieldProps = {
  label: React.ReactNode;
  children: React.ReactNode;
};

export function DetailDataCardField({ label, children }: FieldProps) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" component="div">
        {label}
      </Typography>
      <Box sx={{ mt: 0.25, wordBreak: "break-word" }}>{children}</Box>
    </Box>
  );
}

type CardProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  onClick?: () => void;
};

export function DetailDataCard({ children, sx, onClick }: CardProps) {
  return (
    <Paper
      variant="outlined"
      onClick={onClick}
      sx={{
        p: 1.5,
        width: "100%",
        boxSizing: "border-box",
        ...(onClick ? { cursor: "pointer" } : {}),
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
        {children}
      </Box>
    </Paper>
  );
}
